import { routes as authRoutes } from '#/auth/auth.routes';
import { routes as dashboardRoutes } from '#/dashboard/dashboard.routes';
import { createRouter, createWebHistory, type RouteRecordNormalized } from 'vue-router';

import { useAuthStore } from '@/views/auth/auth.store';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    authRoutes,
    dashboardRoutes,
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, _, next) => {
  const user = useAuthStore().user;
  const parent: RouteRecordNormalized | undefined = to.matched[to.matched.length - 2];

  if (parent) {
    if (parent.name === 'auth') {
      if (user && to.name !== 'auth:logout') {
        return next('/');
      }
    }

    if (parent.name !== 'auth' && !user) {
      return next('/auth/login');
    }
  }

  return next();
});

export default router;
